import axios from "axios";

import { User } from "../../types/user/user";

export async function resetAccount(accountId: string): Promise<User> {
  const { data } = await axios.get(`/accounts/${accountId}/reset`);
  return data;
}
